import React, {Component} from 'react';
import {Badge, Tag} from 'antd';

class FilterStateBadgeTag extends Component {
  state = {
    disconnectChecked: false,
    dangerousChecked: true,
    warningChecked: true,
    normalChecked: true
  };

  disconnectHandleChange = () => {
    const {disconnectChecked} = this.state
    this.setState({
      disconnectChecked: !disconnectChecked,
      dangerousChecked: disconnectChecked,
      warningChecked: disconnectChecked,
      normalChecked: disconnectChecked
    });
    const connected = disconnectChecked
      ? 1
      : 0
    this.props.onConnectionCheck(connected)
  }

  dangerousHandleChange = () => {
    const {dangerousChecked, warningChecked, normalChecked} = this.state
    let alarms = []
    if (!dangerousChecked) {
      alarms.push(2)
    }
    if (warningChecked) {
      alarms.push(1)
    }
    if (normalChecked) {
      alarms.push(0)
    }
    this.props.onAlarmCheck(alarms)
    this.setState({
      dangerousChecked: !dangerousChecked,
      disconnectChecked: false
    });
  }

  warningHandleChange = () => {
    const {dangerousChecked, warningChecked, normalChecked} = this.state
    let alarms = []
    if (dangerousChecked) {
      alarms.push(2)
    }
    if (!warningChecked) {
      alarms.push(1)
    }
    if (normalChecked) {
      alarms.push(0)
    }
    this.props.onAlarmCheck(alarms)
    this.setState({
      warningChecked: !warningChecked,
      disconnectChecked: false
    });
  }

  normalHandleChange = () => {
    const {dangerousChecked, warningChecked, normalChecked} = this.state
    let alarms = []
    if (dangerousChecked) {
      alarms.push(2)
    }
    if (warningChecked) {
      alarms.push(1)
    }
    if (!normalChecked) {
      alarms.push(0)
    }
    this.props.onAlarmCheck(alarms)
    this.setState({
      normalChecked: !normalChecked,
      disconnectChecked: false
    });
  }

  render() {
    const {disconnectChecked, dangerousChecked, warningChecked, normalChecked} = this.state
    const {disconnect, dangerous, warning, normal, isMobile} = this.props

    const styleDisconnect = !disconnectChecked
      ? 'ant-tag-disconnect-uncheck'
      : ''
    const elDisconnect = !isMobile
      ? <span className="tag">
          <Badge count={disconnect}>
            <Tag color="grey" checked={disconnectChecked} onClick={this.disconnectHandleChange} className={styleDisconnect}>
              Mất kết nối</Tag>
          </Badge>
        </span>
      : <span className="tag-mobile">
        <Tag color="grey" checked={disconnectChecked} onClick={this.disconnectHandleChange} className={styleDisconnect}>
          {disconnect}</Tag>
      </span>

    const styleDangerous = !dangerousChecked
      ? 'ant-tag-dangerous-uncheck'
      : ''

    const elDangerous = !isMobile
      ? <span className="tag">
          <Badge count={dangerous}>
            <Tag color="#d4380d" checked={warningChecked} onClick={this.dangerousHandleChange} className={styleDangerous}>Nguy hiểm</Tag>
          </Badge>
        </span>
      : <span className="tag-mobile">
        <Tag color="#d4380d" checked={warningChecked} onClick={this.dangerousHandleChange} className={styleDangerous}>{dangerous}</Tag>
      </span>

    const styleWarning = !warningChecked
      ? 'ant-tag-warning-uncheck'
      : ''

    const elWarning = !isMobile
      ? <span className="tag">
          <Badge count={warning}>
            <Tag color="#fa8c16" checked={warningChecked} onClick={this.warningHandleChange} className={styleWarning}>Cảnh báo</Tag>
          </Badge>
        </span>
      : <span className="tag-mobile">
        <Tag color="#fa8c16" checked={warningChecked} onClick={this.warningHandleChange} className={styleWarning}>{warning}</Tag>
      </span>

    const styleNormal = !normalChecked
      ? 'ant-tag-normal-uncheck'
      : ''
    const elNormal = !isMobile
      ? <span className="tag">
          <Badge count={normal} style={{ backgroundColor: '#52c41a' }}>
            <Tag color="#2D8010" checked={normalChecked} onClick={this.normalHandleChange} className={styleNormal}>Bình thường</Tag>
          </Badge>
        </span>
      : <span className="tag-mobile">
        <Tag color="#2D8010" checked={normalChecked} onClick={this.normalHandleChange} className={styleNormal}>{normal}</Tag>
      </span>
    return (<div>{
        disconnect !== 0
          ? elDisconnect
          : null
      }{
        dangerous !== 0
          ? elDangerous
          : null
      }
      {
        warning !== 0
          ? elWarning
          : null
      }{
        normal !== 0
          ? elNormal
          : null
      }</div>)
  }
}

export default FilterStateBadgeTag;



// WEBPACK FOOTER //
// ./src/components/FilterStateBadgeTag.js